import React from "react"
import { Controller } from "react-hook-form"
import TextInputM from "@common/components/input/TextInputM"
import SelectBox from "@common/components/select/selectSingle-Multiple"
import { countryOptions } from "@data/constants/formConstants"

export function AddressFormFields({
    control,
    errors,
    spacing = 10,
    selectBoxWidth,
    inputWidth,
    streetRef,
    complementRef,
    postalCodeRef,
    cityRef,
}) {
    return (
        <>
            <TextInputM
                ref={streetRef}
                contentContainerStyle={{ marginBottom: spacing }}
                placeholder="ex : 12 rue de la Paix"
                name="street"
                labelTop="Adresse"
                control={control}
                errors={errors}
                width={inputWidth}
                returnKeyType="next"
                onSubmitEditing={() => complementRef?.current?.focus()}
                blurOnSubmit={false}
            />

            <TextInputM
                ref={complementRef}
                contentContainerStyle={{ marginBottom: spacing }}
                placeholder="Bâtiment, étage, etc."
                name="complement"
                labelTop="Complément d'adresse"
                control={control}
                errors={errors}
                width={inputWidth}
                returnKeyType="next"
                onSubmitEditing={() => postalCodeRef?.current?.focus()}
                blurOnSubmit={false}
            />

            <TextInputM
                ref={postalCodeRef}
                contentContainerStyle={{ marginBottom: spacing }}
                placeholder="ex : 75001"
                name="postal_code"
                labelTop="Code postal"
                control={control}
                errors={errors}
                width={inputWidth}
                returnKeyType="next"
                onSubmitEditing={() => cityRef?.current?.focus()}
                blurOnSubmit={false}
            />

            <TextInputM
                ref={cityRef}
                contentContainerStyle={{ marginBottom: spacing }}
                placeholder="ex : Paris"
                name="city"
                labelTop="Ville"
                control={control}
                errors={errors}
                width={inputWidth}
                returnKeyType="done"
            />

            <Controller
                control={control}
                name="country"
                render={({ field: { onChange, value } }) => (
                    <SelectBox
                        title="Pays"
                        options={countryOptions}
                        value={value}
                        width={selectBoxWidth}
                        buttonStyle={{ height: 60 }}
                        onSingleSelect={(value) => {
                            onChange(value)
                        }}
                    />
                )}
            />
        </>
    )
}
